module.exports = __webpack_public_path__ + "static/media/affiliates-icon-active.2dcc4f4d.svg";